module.exports = __webpack_public_path__ + "28334cfc129d2914f66849b13703c40e.jpg";